import React from "react";
import { ThemeType } from "@labci/bell-fg-widgets";
import "./CircularProgress.css";

interface CircularProgressProps {
  size?: number;
  thickness?: number;
  /** Colour band; drives `--color-brand` */
  theme?: ThemeType;
  className?: string;
  style?: React.CSSProperties;
}

/** Indeterminate circular progress for antd's `<Spin indicator>`. */
const CircularProgress: React.FC<CircularProgressProps> = ({
  size = 40,
  thickness = 3.6,
  theme,
  className,
  style,
}) => {
  const radius = (44 - thickness) / 2;
  return (
    <span
      className={`circular-progress ${className || ""}`}
      data-theme={theme}
      role="progressbar"
      aria-label="loading"
      style={{ width: size, height: size, ...style }}
    >
      <svg viewBox="22 22 44 44" width={size} height={size}>
        <circle
          className="circular-progress__track"
          cx="44"
          cy="44"
          r={radius}
          fill="none"
          strokeWidth={thickness}
        />
        <circle
          className="circular-progress__indicator"
          cx="44"
          cy="44"
          r={radius}
          fill="none"
          strokeWidth={thickness}
        />
      </svg>
    </span>
  );
};

export default CircularProgress;
